import { render, staticRenderFns } from "./share.vue?vue&type=template&id=a36cc0a6&scoped=true"
import script from "./share.vue?vue&type=script&lang=ts"
export * from "./share.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36cc0a6",
  null
  
)

export default component.exports